module.exports = __webpack_public_path__ + "static/mentor-ritu-singal-9447c7aa921fd4400ed851ad7aaabc2a.jpg";